import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import useTranslationHook from "../../../../hooks/useTranslationHook";
import { updateBuyerRegistrationField } from "../../../../../redux/slice/buyerSlice";
import { BUYER_REGISTRATION_STEPS } from "./constant";
import { formatPrice, toEasternArabicNumerals } from "../../../../../helpers";
import { useLocation } from "react-router-dom";
import { handleAuctionBidRegistration } from "../../../../../redux/action/buyerAction";
import { toast } from "react-toastify";

function LotSelection() {
    const dispatch = useDispatch();
    const location = useLocation();
    const lots = useSelector((state) => state.liveAuction.lots);
    const { selectedSessionID, lotID } = location?.state || {};
    const { t } = useTranslationHook();
    const { selectedLots } = useSelector(
        (state) => state.buyer.buyerRegistration
    );
    let lang = useSelector((state) => state.translation.lang);
    const registration_id = useSelector(
        (state) => state.buyer.buyerRegistration.registration_id
    );
    const data = lots?.data ?? [];

    const setBuyerField = useCallback((field, value) => {
        dispatch(updateBuyerRegistrationField({ field, value }));
    }, []);

    const handleCheckboxChange = (id) => {
        const updatedLots = selectedLots?.includes(id)
            ? selectedLots.filter((item) => item !== id)
            : [...selectedLots, id];

        setBuyerField("selectedLots", updatedLots);
    };

    const goToNextStep = () => {
        setBuyerField("step", BUYER_REGISTRATION_STEPS.Bidding_Limit);
    };

    const submitLotSelection = async () => {
        const payload = {
            registration_id: registration_id,
            auction_session: selectedSessionID,
            lots: selectedLots,
            step: 2,
        };

        const response = await dispatch(handleAuctionBidRegistration(payload));
        const { code, error, msg, data } = response || {};

        if (code !== 1 || error !== 0) {
            toast.info(msg || "Something went wrong");
            // console.info("Registration Detail Error:", response);
            return;
        }
        toast.success(msg);

        goToNextStep();
    };

    return (
        <div className="step-2">
            <section className="lot-progress">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-10 col-sm-12">
                            <h5>
                                <span>
                                    {t("STEP 2/4")} <circle></circle>{" "}
                                    {t("Registering for Live Auction Name")}
                                </span>
                                {t("Tell us what you’re interested in")}
                                <em>
                                    {t(
                                        "This won’t affect your ability to bid. You can bid on any property during the auction."
                                    )}
                                </em>
                            </h5>
                            <ul>
                                <li className="step active"></li>
                                <li className="step"></li>
                                <li></li>
                                <li></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="lot-form">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-10 col-sm-12">
                            <div className="lot-prop scroll">
                                {/* active */}
                                {data
                                    ?.filter(
                                        (item) =>
                                            item?.lot_status?.status_id === 1
                                    )
                                    .map((item, key) => {
                                        return (
                                            <div className="block" key={key}>
                                                <figure>
                                                    <img
                                                        className="slide-fixed"
                                                        src="/img/trans-3x2.png"
                                                        alt=""
                                                    />
                                                    <img
                                                        className="slide-img"
                                                        src={`${process.env.REACT_APP_AZURE_BLOB_URL}${item?.cover_image?.[0]?.bucket_name}/${item?.cover_image?.[0]?.doc_file_name}`}
                                                        alt="Property Pic"
                                                    />
                                                </figure>

                                                <figcaption>
                                                    <div className="top">
                                                        <div className="id">
                                                            {
                                                                item
                                                                    ?.property_auction_data?.[0]
                                                                    ?.auction_unique_id
                                                            }
                                                        </div>
                                                        <h6>
                                                            {lang === "en"
                                                                ? item.property_name
                                                                : item?.property_name_ar}
                                                            <span>
                                                                {lang === "en"
                                                                    ? item?.community
                                                                    : item?.community_ar}
                                                                , {item?.state}
                                                            </span>
                                                        </h6>
                                                    </div>
                                                    <div className="types">
                                                        <ul>
                                                            <li>
                                                                <img
                                                                    src="/img/bed-icon.svg"
                                                                    alt=""
                                                                />
                                                                {item?.beds !==
                                                                "studio"
                                                                    ? toEasternArabicNumerals(
                                                                          item?.beds
                                                                              ?.slice(
                                                                                  0,
                                                                                  2
                                                                              )
                                                                              .trim(),
                                                                          lang
                                                                      )
                                                                    : ""}{" "}
                                                                {`${item?.beds}`.toLowerCase() ===
                                                                "studio"
                                                                    ? t(
                                                                          "Studio"
                                                                      )
                                                                    : t(
                                                                          toEasternArabicNumerals(
                                                                              item?.beds
                                                                                  ?.slice(
                                                                                      0,
                                                                                      2
                                                                                  )
                                                                                  .trim(),
                                                                              lang
                                                                          ) ===
                                                                              "1"
                                                                              ? "Bed"
                                                                              : "Beds"
                                                                      )}
                                                            </li>
                                                            <li>
                                                                <img
                                                                    src="/img/bath-icon.svg"
                                                                    alt=""
                                                                />{" "}
                                                                {item?.baths ||
                                                                    0}{" "}
                                                                Baths
                                                            </li>
                                                            <li>
                                                                <img
                                                                    src="/img/ruler-icon.svg"
                                                                    alt=""
                                                                />{" "}
                                                                {item?.square_footage ||
                                                                    0}{" "}
                                                                sqft
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </figcaption>

                                                <div className="price">
                                                    <h6>
                                                        {t("ESTIMATE")}
                                                        <span>
                                                            <em className="dirham">
                                                                D
                                                            </em>{" "}
                                                            {formatPrice(
                                                                item?.estimated_price,
                                                                lang,
                                                                "",
                                                                false
                                                            )}
                                                        </span>
                                                    </h6>
                                                    <div className="check">
                                                        {/* <input type="checkbox" className='css-checkbox' id='price' />
                                                    <label htmlFor="price" className='css-label'>&nbsp;</label> */}
                                                        <input
                                                            type="checkbox"
                                                            className="css-checkbox"
                                                            id={`price-${item?.id}`}
                                                            checked={selectedLots?.includes(
                                                                item?.id
                                                            )}
                                                            onChange={() =>
                                                                handleCheckboxChange(
                                                                    item?.id
                                                                )
                                                            }
                                                        />
                                                        <label
                                                            htmlFor={`price-${item?.id}`}
                                                            className="css-label"
                                                        >
                                                            &nbsp;
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>

                            <div className="bidder-btns mt-4">
                                <button
                                    type="button"
                                    className="btn btn-sky back-btn"
                                    onClick={() => {
                                        setBuyerField(
                                            "step",
                                            BUYER_REGISTRATION_STEPS.DETAILS
                                        );
                                    }}
                                >
                                    <img
                                        src="/img/arrow-left.svg"
                                        alt=""
                                        className="mr4"
                                    />
                                    Back
                                </button>
                                {data?.length > 0 && (
                                    <>
                                        {(selectedLots?.length ?? 0) === 0 && (
                                            <button
                                                type="button"
                                                className="skip"
                                                onClick={goToNextStep}
                                            >
                                                {t("Skip this step")}
                                            </button>
                                        )}

                                        <button
                                            type="button"
                                            className="btn btn-primary forward-btn"
                                            onClick={submitLotSelection}
                                        >
                                            {t("Save preferences")}
                                            <img
                                                src="/img/arrow-right.svg"
                                                alt=""
                                                className="ml4"
                                            />
                                        </button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default LotSelection;
